import { ErrorHandler, Injectable } from '@angular/core';
import { clientErrorReporter } from './client-error-reporter';

/**
 * Replaces Angular's default ErrorHandler: prints the error like before, then reports it.
 * It prints with the original console.error, so the console patch does not report it twice.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    public handleError(error: unknown): void {
        clientErrorReporter.originalConsoleError('ERROR', error);
        clientErrorReporter.reportError(error, 'js');
    }
}
